import { render, staticRenderFns } from "./connection-intenso.vue?vue&type=template&id=1942647c&scoped=true&"
import script from "./connection-intenso.ts?vue&type=script&lang=ts&"
export * from "./connection-intenso.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942647c",
  null
  
)

export default component.exports